import {api} from "api";
import {State} from "./types";
import {CreditModel} from "interfaces";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {thunkBadRequest} from "global/thunk-error";
import {setRequestStatus} from "../request-status";
import {setCreditsPagination, setCreditsSliceRequestStatus} from ".";

export const get = createAsyncThunk(
  "credits/get",
  async (pagination: State["pagination"], {dispatch, rejectWithValue}) => {
    const {refresh = false, pos, lim, ser, hasMore} = pagination;
    dispatch(setCreditsPagination({pos, lim, ser, hasMore}));
    if (refresh) {
      dispatch(
        setCreditsSliceRequestStatus({
          name: "credits",
          status: setRequestStatus("initial"),
        })
      );
    }

    try {
      const data = (
        await api.Get<{
          rows: CreditModel[];
          count: number;
        }>(`/formularios/getAll?position=${pos}&limit=${lim}&search=${ser}`)
      )["data"];
      return {data, refresh};
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  }
);
